import { render, staticRenderFns } from "./ab-upload.vue?vue&type=template&id=312b8894&scoped=true"
import script from "./ab-upload.vue?vue&type=script&lang=js"
export * from "./ab-upload.vue?vue&type=script&lang=js"
import style0 from "./ab-upload.vue?vue&type=style&index=0&id=312b8894&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b8894",
  null
  
)

export default component.exports